var $ = require('../internals/export');

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.number.is-nan.js
// module id = 330
// module chunks = 0